import { breakpoints } from "@otta/design-tokens";

export const NAV_BAR_WIDTH = 78;

export const PAGE_CONTENT_CONTAINER_PADDING = 24;

// This breakpoint is used to know when the content of the analytics page isn't full width
export const ANALYTICS_DESKTOP_BREAKPOINT =
  breakpoints.desktop + NAV_BAR_WIDTH + PAGE_CONTENT_CONTAINER_PADDING * 2;
